import { post } from '../../../../../api/baseUrl';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import type { RootState } from '../../../../../store';
import { UpdateCatalogMedPayload } from '../types';

export interface AddCatalogMedPayload
  extends Omit<UpdateCatalogMedPayload, 'tenancyId'> {}

export const useAddCatalogMed = () => {
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { selectedTenancy } = useSelector(
    (state: RootState) => state.clinicianProfile,
  );

  const postAddCatalogMed = async (payload: AddCatalogMedPayload) => {
    if (!selectedTenancy) return;
    setIsLoading(true);
    try {
      await post(`updateCatalogMed`, {
        ...payload,
        tenancyId: selectedTenancy.tenancy_id,
      });
    } catch (error: any) {
      console.error('An error occurred during updateCatalogMed', error);
      setErrorMessage(
        error?.response?.data?.message || 'Unknown error in updateCatalogMed',
      );
    } finally {
      setIsLoading(false);
    }
  };

  return {
    postAddCatalogMed,
    errorMessage,
    isLoading,
  };
};
